import { render, staticRenderFns } from "./tax-info.vue?vue&type=template&id=1fd0d761"
import script from "./tax-info.vue?vue&type=script&lang=js"
export * from "./tax-info.vue?vue&type=script&lang=js"
import style0 from "./tax-info.vue?vue&type=style&index=0&id=1fd0d761&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports